import { forwardRef } from 'react';
import './Bubble.scss';

const Bubble = forwardRef(function Bubble(
  { text, show, position = 'right' },
  ref
) {
  return (
    <div ref={ref} className={'bubble ' + position + (show ? ' show' : '')}>
      <div className={'arrow ' + position} />
      <p className='text'>{text}</p>
    </div>
  );
});

export default Bubble;
